import BaseService from './base';
import request from '../utils/request';
export interface UserViewModel {
  id?: string;
  userName?: string;
  email?: string;
  password?: string;
  passwordn?: string;
  passwordc?: string;
  phoneNumber?: string;
  schoolID?: number;
  userNo?: string;
  realName?: string;
  deptName?: string;
  userType?: number;
  gender?: number;
  openId?: string;
  registerCode?: string;
  status?: number;
  content?: string;
}

export class UserService extends BaseService<UserViewModel> {

  protected serviceApi: string = 'User';

  get NewModel(): UserViewModel {
    return {
      id: '',
      userName: '',
      userType: 0,
      gender: 1,
    };
  }

  public Register(data: UserViewModel) {
    return request({
      url: `${this.serviceApi}/Register`,
      method: 'post',
      data: data,
    });
  }

  public GetInfo() {
    return request({
      url: `${this.serviceApi}/GetInfo`,
      method: 'get',
    });
  }

  public ChangePassword(user: UserViewModel) {
    return this.Put(user, '/ChangePassword');
  }

  public ResetPassword(user: UserViewModel) {
    return this.Post(user, '/ResetPassword');
  }

  public ImportUser(user: UserViewModel) {
    return super.Post(user, '/Import');
  }
}
